
























































import { Component, Prop, Mixins } from 'vue-property-decorator';
import {
  IPricingTableColumn,
  IPricingTableCurrencySettings,
  IPricingTableSummaryValues,
} from '@lib-shared/editor/types';
import { PricingTableHelper } from '@lib-shared/editor/helpers/pricing-table.helper';
import PricingTablePriceSummaryRoot from '@lib-shared/editor/mixins/pricing-table-price-summary-root';

@Component({
  data: () => ({
    PricingTableHelper,
  }),
})
export default class PricingTablePriceSummary extends Mixins(PricingTablePriceSummaryRoot) {
  @Prop() summaryValues: IPricingTableSummaryValues;
  @Prop() sectionSummary: IPricingTableSummaryValues;
  @Prop() columns: IPricingTableColumn[];
  @Prop() currencySettings: IPricingTableCurrencySettings;
  @Prop() isPreCalculated: boolean;

  get totalDiscountValue(): string {
    if (this.totalDiscountIsEmpty) {
      return '';
    }
    return this.totalDiscount;
  }

  get totalTaxValue(): string {
    if (this.totalTaxIsEmpty) {
      return '';
    }
    return this.totalTax;
  }
}
